import axios from 'axios';
import { SearchResultsLayoutGrid } from 'components/BionicUI/layout/CardsLayoutGrid';
import Card from 'components/BionicUI/layout/card/Card';
import CardContent from 'components/BionicUI/layout/card/CardContent';
import { Skeleton } from 'components/BionicUI/ui/skeleton';
import { FC, useEffect, useState } from 'react';
import { Disclaimer } from './Disclaimer';
import { SearchContext } from '../GlobalSearchPopup';
import CardIcon from 'components/BionicUI/layout/card/CardIcon';

interface SearchResultCardsProps {
  searchContext?: SearchContext;
}

const SearchResultCards: FC<SearchResultCardsProps> = ({ searchContext }) => {
  const [cards, setCards] = useState<[]>();

  async function getCards() {
    const data = JSON.stringify({});

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://ze7j62.buildship.run/zero/v1/search/cards',
      headers: { 'Content-Type': 'application/json' },
      data: data,
    };

    axios
      .request(config)
      .then((response) => setCards(response.data.Cards))
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    getCards();
  }, []);

  return (
    <SearchResultsLayoutGrid>
      {searchContext?.scope === 'project' && (
        <div className="grid relative gap-5 grid-cols-[auto_1fr] col-span-3 items-center text-[30px]">
          <CardIcon
            iconImageUrl={searchContext?.project?.iconImageUrl}
            animate
            forceFullSize
          />
          <div>{searchContext?.project?.name}</div>
        </div>
      )}
      {cards ? (
        cards.map((card: any, idx: number) => {
          return (
            <Card
              cols={3}
              key={`search_result_card_${idx}`}
              title={card.CardTitle}
              subtitle={card.CardSubTitle}
              icon={'document'}
            >
              <CardContent padSides padForTitleBar>
                {card.CardContent}
              </CardContent>
            </Card>
          );
        })
      ) : (
        <CardSkeleton />
      )}
      <Disclaimer />
    </SearchResultsLayoutGrid>
  );
};

const CardSkeleton: FC = () => (
  <Card cols={3}>
    <>
      <Skeleton className="block absolute top-[30px] left-[30px] w-[40px] h-[40px] rounded-[6px] opacity-40" />
      <div className="grid absolute top-[30px] left-[85px] w-full max-w-[600px] h-auto gap-[7px] opacity-40">
        <Skeleton className="w-[40%] h-[19px] rounded-[3px] mb-[1px]" />
        <Skeleton className="w-[40%] h-[14px] rounded-[3px]" />
      </div>
      <CardContent padSides padForTitleBar>
        <div className="grid relative w-full max-w-[600px] h-auto gap-3 opacity-40 mb-[30px]">
          <Skeleton className="w-[75%] h-[16px] rounded-[3px]" />
          <Skeleton className="w-[55%] h-[16px] rounded-[3px]" />
          <Skeleton className="w-[59%] h-[16px] rounded-[3px]" />
          <Skeleton className="w-[35%] h-[16px] rounded-[3px]" />
        </div>
      </CardContent>
    </>
  </Card>
);

export default SearchResultCards;
